module.exports = __webpack_public_path__ + "static/media/dedicated_agency.3ff3477c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/dedicated_agency.svg
// module id = 2704
// module chunks = 0